import type { MouseEvent } from "react";

/**
 * Modifier-aware whole-row navigation handlers for clickable table rows.
 *
 * The row's primary cell should still render a real wouter <Link> (so
 * right-click "open in new tab" and native anchor semantics work there),
 * but the rest of the row surface uses these handlers so ctrl/cmd-click
 * and middle-click open a new tab instead of hijacking the click into a
 * same-tab JS navigation.
 */
export function rowNavHandlers(href: string, navigate: (to: string) => void) {
  return {
    onClick: (e: MouseEvent<HTMLElement>) => {
      if (e.defaultPrevented) return;
      // Don't steal clicks when the user is selecting text in the row.
      const selection = window.getSelection();
      if (selection && selection.type === "Range") return;
      // Don't navigate when the click originated on a link inside the row
      // (e.g. a wouter <Link> or an external <a>). The link's own behaviour
      // (navigation / new-tab) should win, and the row handler must not
      // duplicate it — especially on ctrl/cmd+click where both the browser
      // default and the row's window.open would otherwise fire.
      const target = e.target as HTMLElement;
      if (target.closest("a")) return;
      if (e.ctrlKey || e.metaKey || e.shiftKey) {
        window.open(href, "_blank", "noopener");
        return;
      }
      navigate(href);
    },
    onAuxClick: (e: MouseEvent<HTMLElement>) => {
      if (e.defaultPrevented) return;
      if (e.button === 1) {
        window.open(href, "_blank", "noopener");
      }
    },
  };
}
